// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_container__84sqx","icon":"notification_icon__2Zt94","button":"notification_button__cAnge"};